import React, { useEffect, useState } from "react";
import "./HorizontalSwitch.css";

interface HorizontalSwitchValuesProps {
  id: number;
  label: string;
  value: string;
}

interface HorizontalSwitchProps {
  value: string;
  values: HorizontalSwitchValuesProps[];
  onChange: (selectedValue: string) => void;
  className?: string;
  disabled?: boolean;
}

const HorizontalSwitch: React.FC<HorizontalSwitchProps> = ({
  value,
  values,
  onChange,
  className,
  disabled = false,
}) => {
  const [activeValue, setActiveValue] = useState<string>(value);

  // onChange fires only on a real click. It used to fire from an effect on
  // every mount/render, which let a remounted switch write its value back into
  // state and silently undo an unrelated selection.
  const handleItemClick = (value: string) => {
    setActiveValue(value);
    onChange(value);
  };

  useEffect(() => {
    setActiveValue(value);
  }, [value]);

  return (
    <div className={`horizontal-switch ${disabled ? "disabled" : ""} ${className ?? ""}`}>
      {values.map((value) => (
        <div
          key={value.id}
          className={`horizontal-switch-item ${
            activeValue === value.value ? "select" : ""
          }`}
          onClick={(event) => {
            event.stopPropagation();
            if (disabled) return;
            handleItemClick(value.value);
          }}
        >
          <span>{value.label}</span>
        </div>
      ))}
    </div>
  );
};

export default HorizontalSwitch;
